// extracted by mini-css-extract-plugin
export default {"link":"kC-z","disabled":"lC-z"};